import { LocalStorageFactory, Storage } from '@ac/library-utils/dist/services';

export const LocalStorage: Storage =
  LocalStorageFactory.createLocalStorageForMicroservice('container') as Storage;
